import { render, staticRenderFns } from "./updateCertifiedModal.vue?vue&type=template&id=3a76bcb0&scoped=true&"
import script from "./updateCertifiedModal.vue?vue&type=script&lang=js&"
export * from "./updateCertifiedModal.vue?vue&type=script&lang=js&"
import style0 from "./updateCertifiedModal.vue?vue&type=style&index=0&id=3a76bcb0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a76bcb0",
  null
  
)

export default component.exports